import React from 'react';
import { VStack, Heading } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';
import ResourceItem from '../../../../../task/components/ResourceItem';

const EventResources = ({ resources, isOralExam = false }) => {
  const { t } = useTranslation();

  if (!resources || resources.length === 0) return null;

  return (
    <VStack space="sm">
      <Heading size="sm">
        {isOralExam
          ? t('student.eventTask.resources.oralExamTitle', 'Materials')
          : t('student.eventTask.resources.title', 'Event Materials')}
      </Heading>
      <VStack space="xs">
        {resources.map((resource) => (
          <ResourceItem key={resource.id} resource={resource} thumbnail={resource.thumbnailUrls?.small} />
        ))}
      </VStack>
    </VStack>
  );
};

export default EventResources;
